import React from "react"
import FieldProto from "../../proto/field-proto";
import FieldGlistView from "./glist-view";

// const debug = "FieldGlistEditable"
// const debug = false

export type FieldGlistEditableProps = {
    className?  : string
    field       : FieldProto
    model       : any
    onChange    : onChangeCallback
    module      : any // glist in our case
};

export default function FieldGlistEditable(props:FieldGlistEditableProps):React.ReactElement|null {

    // debug && console.log(debug, "render() access=", props.field.access(props.model))

    switch (props.field.access(props.model)) {
        case false      :
            return null
        case 'read'     :
            return <FieldGlistView {...props} />

        case 'write'    :
        default:
            return <props.field.renderComponents.glistEditable {...props} />
            // break
    }



}
